<template>
  <div class="layer-item">
    <b-form-checkbox :checked="layer.visible" @change="toggleVisible" class="mr-0"></b-form-checkbox>
    <span class="layer-name">
      {{ layer.title }}
    </span>
    <a href="#" class="action text-success" title="Zapisz" @click="save()">
      <span class="oi oi-circle-check"></span>
    </a>
    <a href="#" class="action text-danger" title="Usuń" @click="remove()">
      <span class="oi oi-circle-x"></span>
    </a>
  </div>
</template>

<script>
import { TEMPORARY_LAYER_REMOVE, TEMPORARY_LAYER_SAVE, TEMPORARY_LAYER_TOGGLE_VISIBILITY } from '../store/actions.type';

export default {
  props: {
    layer: { type: Object, required: true }
  },
  methods: {
    async save() {
      await this.$store.dispatch(TEMPORARY_LAYER_SAVE, this.layer);
    },
    remove() {
      this.$store.dispatch(TEMPORARY_LAYER_REMOVE, this.layer);
    },
    toggleVisible() {
      this.$store.dispatch(TEMPORARY_LAYER_TOGGLE_VISIBILITY, this.layer);
    }
  }
}
</script>

<style>
#actions-container {
  margin-left: auto;
}
</style>

